import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evangelism',
  templateUrl: './evangelism.component.html',
  styleUrls: ['./evangelism.component.css']
})
export class EvangelismComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
